import Page from '../Page';
import InviteNewApp from './InviteNewApp.vue';
import InviteNewWeb from './InviteNewWeb.vue';

/* eslint-disable no-new */
new Page({
  routes: [
    {
      path: '/app',
      component: InviteNewApp,
      meta: { title: '邀好友，赚10元赏金' },
      name: 'InviteNewApp'
    },
    {
      path: '/web',
      component: InviteNewWeb,
      meta: { title: '快对作业' },
      name: 'InviteNewWeb'
    }
  ]
});
